import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  },
  {
    path: '/token/:id',
    name: 'token',
    component: () => import(/* webpackChunkName: "token" */ '../views/TokenView.vue')
  },
  {
    path: '/login-mahasiswa',
    name: 'login/mahasiswa',
    component: () => import(/* webpackChunkName: "login-mhs" */ '../views/LoginmahasiswaView.vue')
  },
  {
    path: '/perusahaan',
    name: 'perusahaan',
    component: () => import(/* webpackChunkName: "perusahaan" */ '../views/PerusahaanView.vue')
  },
  {
    path: '/mahasiswa',
    name: 'mahasiswa',
    component: () => import(/* webpackChunkName: "mahasiswa" */ '../views/MahasiswaView.vue')
  },
  {
    path: '/dosen',
    name: 'dosen',
    component: () => import(/* webpackChunkName: "dosen" */ '../views/DosenView.vue')
  },
  {
    path: '/jenis',
    name: 'jenis',
    component: () => import(/* webpackChunkName: "jenis" */ '../views/JenisView.vue')
  },
  {
    path: '/jeniskuota',
    name: 'jeniskuota',
    component: () => import(/* webpackChunkName: "jeniskuota" */ '../views/JenisKuotaView.vue')
  },
  {
    path: '/dokumen',
    name: 'dokumen',
    component: () => import(/* webpackChunkName: "dokumen" */ '../views/DokumenView.vue')
  },
  {
    path: '/prodi',
    name: 'prodi',
    component: () => import(/* webpackChunkName: "prodi" */ '../views/ProdiView.vue')
  },
  {
    path: '/kuota',
    name: 'kuota',
    component: () => import(/* webpackChunkName: "kuota" */ '../views/KuotaView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/RegisterView.vue')
  },
  {
    path: '/register/:id',
    name: 'registerdetail',
    component: () => import(/* webpackChunkName: "registerdetail" */ '../views/RegisterdetailView.vue')
  },
  {
    path: '/kuota/detail/:id',
    name: 'kuotaperusahaan',
    component: () => import(/* webpackChunkName: "kuotaperusahaan" */ '../views/KuotaperusahaanView.vue')
  },
  {
    path: '/dokumenakademik',
    name: 'dokumenakademik',
    component: () => import(/* webpackChunkName: "dokumenakademik" */ '../views/DokumenakademikView.vue')
  },
  {
    path: '/laporan',
    name: 'laporan',
    component: () => import(/* webpackChunkName: "laporan" */ '../views/LaporanView.vue')
  },
  {
    path: '/mahasiswabimbingan',
    name: 'mahasiswabimbingan',
    component: () => import(/* webpackChunkName: "mahasiswabimbingan" */ '../views/MahasiswabimbinganView.vue')
  },
  {
    path: '/mahasiswabimbingan/:id',
    name: 'mahasiswabimbingandetail',
    component: () => import(/* webpackChunkName: "laporandetail" */ '../views/LaporandetailView.vue')
  },
  {
    path: '/monitoring',
    name: 'monitoring',
    component: () => import(/* webpackChunkName: "monitoring" */ '../views/MonitoringView.vue')
  },
  {
    path: '/monitoring/:id',
    name: 'monitoringdetail',
    component: () => import(/* webpackChunkName: "monitoringdetail" */ '../views/MonitoringdetailView.vue')
  },
  {
    path: '/pengaturan',
    name: 'pengaturan',
    component: () => import(/* webpackChunkName: "persyaratan" */ '../views/PersyaratanView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
